import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type ModalDescriptionProps = {
  className?: string;
} & PropsWithChildren;

export const ModalDescription: FC<ModalDescriptionProps> = ({ children, className }) => {
  return <p className={twMerge('text-sm text-tertiary-600', className)}>{children}</p>;
};
